<template>
  <div>
    <div class="detial-cont-view">
      <a-descriptions layout="vertical">
        <a-descriptions-item>
          <span slot="label">单位名称<span class="required">*</span> </span>
          <a-tooltip placement="topLeft" :title="form.unitName">
            <div>
              <a-input
                v-if="form.id"
                class="w300"
                placeholder="请添加"
                v-model="form.unitName"
                disabled
              />
              <a-select
                v-else
                class="w300"
                placeholder="请选择"
                v-model="form.organizationId"
                :disabled="disabled"
              >
                <a-select-option
                  v-for="item in app.organizationUserList"
                  :value="item.organizationId"
                  :key="item.organizationId"
                >
                  {{ item.organizationname }}</a-select-option
                >
              </a-select>
            </div>
          </a-tooltip>
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">姓名<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入姓名"
            v-model="form.name"
            :disabled="disabled"
            @change="emitChange('name', 85)"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">岗位<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入岗位"
            v-model="form.postName"
            :disabled="disabled"
            @change="emitChange('postName', 85)"
          />
        </a-descriptions-item>

        <a-descriptions-item>
          <span slot="label">身份证号码<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入身份证号码"
            v-model="form.idCardNumber"
            :disabled="disabled"
            @change="getBirth(form.idCardNumber)"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">性别<span class="required">*</span> </span>
          <a-select
            class="w300"
            v-model="form.sex"
            placeholder="请选择性别"
            disabled
            @change="emitChange()"
          >
            <a-select-option value="男">男</a-select-option>
            <a-select-option value="女">女</a-select-option>
          </a-select>
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">出生日期<span class="required">*</span> </span>
          <a-date-picker
            class="w300"
            v-model="form.birthDate"
            valueFormat="YYYY-MM-DD"
            placeholder="请选择出生日期"
            disabled
            @change="emitChange()"
          />
        </a-descriptions-item>

        <a-descriptions-item>
          <span slot="label">联系电话1<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入联系电话1"
            v-model="form.phoneNumberOne"
            :disabled="disabled"
            @change="emitChange()"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">联系电话2</span>
          <a-input
            class="w300"
            placeholder="请输入联系电话2"
            v-model="form.phoneNumberTwo"
            :disabled="disabled"
            @change="emitChange()"
          />
        </a-descriptions-item>
        <br />

        <a-descriptions-item label="备注">
          <a-input
            class="w500"
            type="textarea"
            :auto-size="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入备注"
            v-model="form.remark"
            :disabled="disabled"
            @change="emitChange('remark', 200)"
          />
        </a-descriptions-item>
      </a-descriptions>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { validateIdCard } from '@/assets/js/auth.js'
export default {
  props: ['disabled', 'resData', 'formData'],
  model: {
    event: 'input',
    prop: 'formData'
  },
  data() {
    return {
      form: {}
    }
  },
  watch: {
    resData(val) {
      this.form = val
    }
  },
  mounted() {
    // 获取组织机构
    this.getorganizationUserList()
    if (!this.form.id) {
      // 新增
      this.$set(
        this.form,
        'organizationId',
        this.$store.state.app.organizationId
      )
    }
  },
  computed: {
    ...mapState(['app'])
  },
  methods: {
    ...mapActions(['getorganizationUserList']),
    emitChange(v, maxNum) {
      if (v) {
        this.eightyfive(v, maxNum)
      }
      this.$emit('input', this.form)
    },
    // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.form[v].length > maxNum) {
        this.form[v] = this.form[v].substring(0, maxNum)
        this.$message.destroy()
        this.$message.warning('只能输入' + maxNum + '个字')
      }
    },
    //根据身份证号获取出生日期和身份证号
    getBirth(idCard) {
      // console.log(idCard)
      let w = validateIdCard(idCard)
      if (w) {
        // 正确的身份证号
        let birthday = idCard.slice(6, 14)
        this.form.birthDate = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
        if (parseInt(idCard.slice(-2, -1)) % 2 == 1) {
          this.form.sex = '男'
        } else {
          this.form.sex = '女'
        }
      }
      this.$emit('input', this.form)
    }
  }
}
</script>
<style lang="scss" scoped>
.detial-cont-view {
  background: #fff;
  padding: 30px;
  .accessory-btn {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/baseInfoManagement/securityInfo/components/formBaseInfo.vue